module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Bold.d0bb8f30.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Bold.woff2
// module id = 3330
// module chunks = 51